/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassShort } from './MktuClassShort'
import {
  MktuClassShortFromJSON,
  MktuClassShortFromJSONTyped,
  MktuClassShortToJSON,
} from './MktuClassShort'
import type { GetRegistry200ResponseDataDocuments } from './GetRegistry200ResponseDataDocuments'
import {
  GetRegistry200ResponseDataDocumentsFromJSON,
  GetRegistry200ResponseDataDocumentsFromJSONTyped,
  GetRegistry200ResponseDataDocumentsToJSON,
} from './GetRegistry200ResponseDataDocuments'
import type { GetRegistry200ResponseDataImage } from './GetRegistry200ResponseDataImage'
import {
  GetRegistry200ResponseDataImageFromJSON,
  GetRegistry200ResponseDataImageFromJSONTyped,
  GetRegistry200ResponseDataImageToJSON,
} from './GetRegistry200ResponseDataImage'
import type { GetRegistry200ResponseDataCounts } from './GetRegistry200ResponseDataCounts'
import {
  GetRegistry200ResponseDataCountsFromJSON,
  GetRegistry200ResponseDataCountsFromJSONTyped,
  GetRegistry200ResponseDataCountsToJSON,
} from './GetRegistry200ResponseDataCounts'

/**
 *
 * @export
 * @interface GetRegistry200ResponseData
 */
export interface GetRegistry200ResponseData {
  /**
   *
   * @type {GetRegistry200ResponseDataImage}
   * @memberof GetRegistry200ResponseData
   */
  image?: GetRegistry200ResponseDataImage
  /**
   *
   * @type {GetRegistry200ResponseDataCounts}
   * @memberof GetRegistry200ResponseData
   */
  counts?: GetRegistry200ResponseDataCounts
  /**
   * Номер свидетельства (только ТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  registrationNumber?: string | null
  /**
   * Номер заявки (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  applicationNumber?: string | null
  /**
   * Наименование правообладателя (только ТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  rightholderName?: string | null
  /**
   * Адрес правообладателя (только ТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  rightholderAddress?: string | null
  /**
   * Наименование заявителя (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  applicantName?: string | null
  /**
   * Адрес заявителя (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  applicantAddress?: string | null
  /**
   * Email заявителя (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  applicantEmail?: string | null
  /**
   * Адрес для переписки (только ТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  correspondenceNameAddress?: string | null
  /**
   * Адресат для переписки (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  correspondenceName?: string | null
  /**
   * Адрес для переписки (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  correspondenceAddress?: string | null
  /**
   * Патентный поверенный (только зТЗ)
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  representativeName?: string | null
  /**
   * Неохраняемые элементы
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  unprotectedElements?: string | null
  /**
   * Сведения о цвете
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  colorInfo?: string | null
  /**
   *
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  registrationOfficeCode?: string
  /**
   * Классы МКТУ
   * @type {Array<MktuClassShort>}
   * @memberof GetRegistry200ResponseData
   */
  mktuClasses?: Array<MktuClassShort>
  /**
   * Ключевые даты записи: приоритет, подача, регистрация, публикация, истечение действия
   * @type {object}
   * @memberof GetRegistry200ResponseData
   */
  dates?: object | null
  /**
   *
   * @type {GetRegistry200ResponseDataDocuments}
   * @memberof GetRegistry200ResponseData
   */
  documents?: GetRegistry200ResponseDataDocuments
  /**
   * Ссылка на источник свидетельства
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  registrationSourceLink?: string | null
  /**
   * Ссылка на источник заявки
   * @type {string}
   * @memberof GetRegistry200ResponseData
   */
  applicationSourceLink?: string | null
}

/**
 * Check if a given object implements the GetRegistry200ResponseData interface.
 */
export function instanceOfGetRegistry200ResponseData(
  value: object
): value is GetRegistry200ResponseData {
  return true
}

export function GetRegistry200ResponseDataFromJSON(
  json: any
): GetRegistry200ResponseData {
  return GetRegistry200ResponseDataFromJSONTyped(json, false)
}

export function GetRegistry200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistry200ResponseData {
  if (json == null) {
    return json
  }
  return {
    image:
      json['image'] == null
        ? undefined
        : GetRegistry200ResponseDataImageFromJSON(json['image']),
    counts:
      json['counts'] == null
        ? undefined
        : GetRegistry200ResponseDataCountsFromJSON(json['counts']),
    registrationNumber:
      json['registrationNumber'] == null
        ? undefined
        : json['registrationNumber'],
    applicationNumber:
      json['applicationNumber'] == null ? undefined : json['applicationNumber'],
    rightholderName:
      json['rightholderName'] == null ? undefined : json['rightholderName'],
    rightholderAddress:
      json['rightholderAddress'] == null
        ? undefined
        : json['rightholderAddress'],
    applicantName:
      json['applicantName'] == null ? undefined : json['applicantName'],
    applicantAddress:
      json['applicantAddress'] == null ? undefined : json['applicantAddress'],
    applicantEmail:
      json['applicantEmail'] == null ? undefined : json['applicantEmail'],
    correspondenceNameAddress:
      json['correspondenceNameAddress'] == null
        ? undefined
        : json['correspondenceNameAddress'],
    correspondenceName:
      json['correspondenceName'] == null
        ? undefined
        : json['correspondenceName'],
    correspondenceAddress:
      json['correspondenceAddress'] == null
        ? undefined
        : json['correspondenceAddress'],
    representativeName:
      json['representativeName'] == null
        ? undefined
        : json['representativeName'],
    unprotectedElements:
      json['unprotectedElements'] == null
        ? undefined
        : json['unprotectedElements'],
    colorInfo: json['colorInfo'] == null ? undefined : json['colorInfo'],
    registrationOfficeCode:
      json['registrationOfficeCode'] == null
        ? undefined
        : json['registrationOfficeCode'],
    mktuClasses:
      json['mktuClasses'] == null
        ? undefined
        : (json['mktuClasses'] as Array<any>).map(MktuClassShortFromJSON),
    dates: json['dates'] == null ? undefined : json['dates'],
    documents:
      json['documents'] == null
        ? undefined
        : GetRegistry200ResponseDataDocumentsFromJSON(json['documents']),
    registrationSourceLink:
      json['registrationSourceLink'] == null
        ? undefined
        : json['registrationSourceLink'],
    applicationSourceLink:
      json['applicationSourceLink'] == null
        ? undefined
        : json['applicationSourceLink'],
  }
}

export function GetRegistry200ResponseDataToJSON(
  value?: GetRegistry200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    image: GetRegistry200ResponseDataImageToJSON(value['image']),
    counts: GetRegistry200ResponseDataCountsToJSON(value['counts']),
    registrationNumber: value['registrationNumber'],
    applicationNumber: value['applicationNumber'],
    rightholderName: value['rightholderName'],
    rightholderAddress: value['rightholderAddress'],
    applicantName: value['applicantName'],
    applicantAddress: value['applicantAddress'],
    applicantEmail: value['applicantEmail'],
    correspondenceNameAddress: value['correspondenceNameAddress'],
    correspondenceName: value['correspondenceName'],
    correspondenceAddress: value['correspondenceAddress'],
    representativeName: value['representativeName'],
    unprotectedElements: value['unprotectedElements'],
    colorInfo: value['colorInfo'],
    registrationOfficeCode: value['registrationOfficeCode'],
    mktuClasses:
      value['mktuClasses'] == null
        ? undefined
        : (value['mktuClasses'] as Array<any>).map(MktuClassShortToJSON),
    dates: value['dates'],
    documents: GetRegistry200ResponseDataDocumentsToJSON(value['documents']),
    registrationSourceLink: value['registrationSourceLink'],
    applicationSourceLink: value['applicationSourceLink'],
  }
}
